import { useCallback, useMemo } from 'react'
import { useSearchParams } from 'react-router-dom'
import {
  type DashboardFilters,
  isFiltered,
  previousRange,
  readFilters,
  resolveRange,
  statsQuery,
  writeFilters,
} from './filters'

/**
 * The dashboard's date range + campaigns, kept in the URL. Every widget
 * reads it so they all show the same slice; `query` is what they append
 * to their API path ('' = unfiltered, the original requests).
 */
export function useDashboardFilters() {
  const [params, setParams] = useSearchParams()
  const filters = useMemo(() => readFilters(params), [params])

  const setFilters = useCallback(
    (next: DashboardFilters) => setParams((prev) => writeFilters(prev, next), { replace: true }),
    [setParams],
  )

  // Recomputed per render so "Last 7 days" rolls over at midnight; the
  // strings only change when the day does, so query keys stay stable.
  const range = resolveRange(filters)
  const query = statsQuery(range, filters.campaignIds)
  const prev = previousRange(range)
  const previousQuery = prev ? statsQuery(prev, filters.campaignIds) : null

  return { filters, setFilters, range, query, previousQuery, filtered: isFiltered(filters) }
}
